var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FieldSelect, FieldWrapper, FormField, FormGrid, InputText, ModalBody, ModalFoot, ModalHead, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import _cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { PureComponent } from 'react';
import * as React from 'react';
import { connect } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { selectFlowLanguagesSorted } from 'app/utils/reselect';
import NumberSelect from 'components/powerFlowShared/components/numberSelect';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { AdapterTypes } from 'components/shared/announcementPicker/adapters';
import { AnnouncementPicker } from 'components/shared/announcementPicker/announcementPicker';
import { QueuePicker } from 'components/shared/queuePicker';
import { Duration } from 'fable/duration';
import { ToggleBox, ToggleBoxBody, ToggleBoxHead } from 'fable/toggleBox';
import styles from './queue.module.scss';
import { getRelevantAncestorWithCallback, hasAncestralCallback, } from './utils/queue/queue-util';
const ANNOUNCEMENT_FIELD = 'announcement';
const QUEUE_FIELD = 'queue';
const LANGUAGE_FIELD = 'language';
const TIMEOUT_FIELD = 'timeout';
const WAIT_MUSIC_FIELD = 'waitMusic';
const CALLBACK_TIMEOUT_FIELD = 'callbackTimeout';
class QueueModalImpl extends PureComponent {
    constructor(props) {
        var _a;
        super(props);
        this.playRecord = React.createRef();
        const { node: { payload }, } = props;
        const _b = payload || {}, { callbackInfo = null } = _b, restPayload = __rest(_b, ["callbackInfo"]);
        const queue = Object.assign({ queue: null, language: null }, restPayload);
        this.initShowWaitMusic = Boolean((queue === null || queue === void 0 ? void 0 : queue.wait_music_v2) && queue.wait_music_v2.id);
        this.initShowCallbackAnnouncement = !!callbackInfo;
        this.state = {
            callbackInfo,
            initState: _cloneDeep(queue),
            language: (_a = queue.language) !== null && _a !== void 0 ? _a : null,
            queue,
            showCustomWaitMusic: this.initShowWaitMusic,
            showCallbackAnnouncement: this.initShowCallbackAnnouncement,
            errors: {},
        };
    }
    saveClickHandler() {
        const { replaceNode } = this.props;
        if (this._validate()) {
            replaceNode(this._prepareNode());
        }
    }
    _getPayload() {
        const { callbackInfo, queue, language } = this.state;
        const { announcement, from_number = '', timeout } = callbackInfo || {};
        return Object.assign(Object.assign(Object.assign({}, queue), { language }), (callbackInfo &&
            announcement && {
            callbackInfo: Object.assign({ announcement, digit: '#', from_number }, (timeout && { timeout })),
        }));
    }
    _prepareNode() {
        var _a, _b;
        const { queue } = this.state;
        const { triggerClose, node } = this.props;
        triggerClose();
        const text = `Queue ${(_b = (_a = queue === null || queue === void 0 ? void 0 : queue.queue) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ''}`;
        const payload = this._getPayload();
        return Object.assign(Object.assign({}, node), { icon: 'i-queue', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.QUEUE, overlay: [], payload,
            text });
    }
    _validate() {
        var _a, _b, _c;
        const { callbackInfo, language, queue, showCallbackAnnouncement, showCustomWaitMusic, } = this.state;
        const { announcement_attributes } = queue;
        const isPlayAnnouncementEnabled = !!(announcement_attributes === null || announcement_attributes === void 0 ? void 0 : announcement_attributes.play_announcement);
        const errors = {};
        if (!(queue === null || queue === void 0 ? void 0 : queue.queue) || !queue.queue.value) {
            errors[QUEUE_FIELD] = 'Selecting a queue is required';
        }
        if (!language && isPlayAnnouncementEnabled) {
            errors[LANGUAGE_FIELD] = 'Selecting a language is required.';
        }
        if (queue.queue_timeout && !queue.queue_timeout.timeout_in_seconds) {
            errors[TIMEOUT_FIELD] = 'Please add seconds before timeout';
        }
        if (((_a = queue.queue_timeout) === null || _a === void 0 ? void 0 : _a.timeout_in_seconds) &&
            (queue.queue_timeout.timeout_in_seconds < 14 ||
                queue.queue_timeout.timeout_in_seconds > 3600)) {
            errors[TIMEOUT_FIELD] = 'Needs to be between 15 seconds and 1 hour';
        }
        if (showCustomWaitMusic &&
            !((_b = queue.wait_music_v2) === null || _b === void 0 ? void 0 : _b.id) &&
            !((_c = queue.wait_music_v2) === null || _c === void 0 ? void 0 : _c.uuid)) {
            errors[WAIT_MUSIC_FIELD] = 'Upload or select an mp3 file';
            const playRecord = this.playRecord.current;
            if (playRecord) {
                playRecord.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        }
        if (showCallbackAnnouncement) {
            if (!(callbackInfo === null || callbackInfo === void 0 ? void 0 : callbackInfo.announcement)) {
                errors[ANNOUNCEMENT_FIELD] = 'Please select an announcement file';
            }
            if (typeof (callbackInfo === null || callbackInfo === void 0 ? void 0 : callbackInfo.timeout) === 'number' &&
                (callbackInfo.timeout < 1 || callbackInfo.timeout > 3600)) {
                errors[CALLBACK_TIMEOUT_FIELD] =
                    'Please select a value of 1 hour or less';
            }
        }
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }
    changeQueue(queue) {
        if (!queue) {
            return;
        }
        this.setState((_a) => {
            var { queue: stateQueue } = _a, _b = _a.errors, _c = QUEUE_FIELD, queueError = _b[_c], errors = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
            return ({
                queue: Object.assign(Object.assign({}, stateQueue), { queue: {
                        value: queue.id,
                        label: queue.name,
                    } }),
                errors,
            });
        });
    }
    toggleEnableTimeout() {
        this.setState(({ queue: stateQueue }, { node }) => {
            var _a, _b, _c;
            const queue = Object.assign({}, stateQueue);
            if (!queue.queue_timeout) {
                if ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.queue_timeout) {
                    queue.queue_timeout = {
                        timeout_in_seconds: parseInt((_b = node.payload) === null || _b === void 0 ? void 0 : _b.queue_timeout.timeout_in_seconds.toString(), 10),
                        timeout_node_id: ((_c = node.payload) === null || _c === void 0 ? void 0 : _c.queue_timeout.timeout_node_id) || uuid(),
                    };
                }
                else {
                    queue.queue_timeout = {
                        timeout_in_seconds: 0,
                        timeout_node_id: uuid(),
                    };
                }
            }
            else {
                delete queue.queue_timeout;
            }
            return { queue };
        });
    }
    togglePlayAnnouncements(playAnnouncement) {
        this.setState((_a) => {
            var stateQueue = __rest(_a.queue, []);
            const queue = Object.assign(Object.assign({}, stateQueue), (stateQueue.announcement_attributes && {
                announcement_attributes: Object.assign({}, stateQueue.announcement_attributes),
            }));
            if (queue.announcement_attributes === undefined) {
                queue.announcement_attributes = {
                    play_announcement: playAnnouncement,
                };
            }
            else {
                queue.announcement_attributes.play_announcement = playAnnouncement;
                delete queue.announcement_attributes.max_announcement_position;
                delete queue.gender;
            }
            return { queue, language: null };
        });
    }
    handleCallbackToggle(hasCallback) {
        this.setState(({ callbackInfo, showCallbackAnnouncement }) => ({
            callbackInfo: hasCallback ? callbackInfo : null,
            showCallbackAnnouncement: !showCallbackAnnouncement,
        }));
    }
    changeLanguage(languageValue) {
        if (!languageValue) {
            return;
        }
        this.setState((_a) => {
            var { queue: stateQueue } = _a, _b = _a.errors, _c = LANGUAGE_FIELD, languageError = _b[_c], errors = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
            const queue = Object.assign({}, stateQueue);
            let language = languageValue;
            if (languageValue.indexOf('%') > -1) {
                language = languageValue.substr(0, languageValue.indexOf('%'));
                queue.gender = languageValue.substr(languageValue.indexOf('%') + 1);
            }
            return { language, queue, errors };
        });
    }
    changeTimeoutInSec(timeoutInSeconds) {
        this.setState((_a) => {
            var _b;
            var { queue: stateQueue } = _a, _c = _a.errors, _d = TIMEOUT_FIELD, timeoutError = _c[_d], errors = __rest(_c, [typeof _d === "symbol" ? _d : _d + ""]);
            return ({
                errors,
                queue: Object.assign(Object.assign({}, stateQueue), { queue_timeout: {
                        timeout_in_seconds: timeoutInSeconds,
                        timeout_node_id: ((_b = stateQueue.queue_timeout) === null || _b === void 0 ? void 0 : _b.timeout_node_id) || uuid(),
                    } }),
            });
        });
    }
    toggleEnableCustomWaitMusic() {
        this.setState((_a) => {
            var { showCustomWaitMusic, queue: queueWithWaitMusic } = _a, _b = _a.queue, { wait_music_v2 } = _b, queue = __rest(_b, ["wait_music_v2"]);
            return ({
                showCustomWaitMusic: !showCustomWaitMusic,
                queue: showCustomWaitMusic ? queue : queueWithWaitMusic,
            });
        });
    }
    updateAudio(audio) {
        this.setState((_a) => {
            var _b = _a.queue, { wait_music_v2 } = _b, queue = __rest(_b, ["wait_music_v2"]), _c = _a.errors, _d = WAIT_MUSIC_FIELD, waitMusicError = _c[_d], errors = __rest(_c, [typeof _d === "symbol" ? _d : _d + ""]);
            return ({
                queue: Object.assign(Object.assign({}, queue), { wait_music_v2: audio }),
                errors,
            });
        });
    }
    handleAnnouncementSelect(announcement) {
        this.setState((_a) => {
            var { callbackInfo } = _a, _b = _a.errors, _c = ANNOUNCEMENT_FIELD, announcementError = _b[_c], errors = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
            return ({
                callbackInfo: Object.assign(Object.assign({}, callbackInfo), { announcement: {
                        file: announcement,
                    } }),
                errors,
            });
        });
    }
    handleOutboundNumberSelect(phoneNumber) {
        this.setState(({ callbackInfo }) => ({
            callbackInfo: Object.assign(Object.assign({}, callbackInfo), { from_number: phoneNumber }),
        }));
    }
    handleTimeoutChange(timeoutInSeconds) {
        this.setState((_a) => {
            var { callbackInfo } = _a, _b = _a.errors, _c = CALLBACK_TIMEOUT_FIELD, callbackTimeoutError = _b[_c], errors = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
            return ({
                callbackInfo: Object.assign(Object.assign({}, callbackInfo), { timeout: timeoutInSeconds }),
                errors,
            });
        });
    }
    changeMaxAnnoucementPosition(event) {
        if (!event) {
            return;
        }
        const { target: { value }, } = event;
        this.setState(({ queue: stateQueue }) => {
            const queue = Object.assign(Object.assign({}, stateQueue), (stateQueue.announcement_attributes && {
                announcement_attributes: Object.assign({}, stateQueue.announcement_attributes),
            }));
            const position = parseInt(value, 10);
            if (queue.announcement_attributes) {
                queue.announcement_attributes.play_announcement = true;
                if (position > 0) {
                    queue.announcement_attributes.max_announcement_position = position;
                }
                else {
                    delete queue.announcement_attributes.max_announcement_position;
                }
            }
            else {
                queue.announcement_attributes = {
                    play_announcement: true,
                };
                if (position > 0) {
                    queue.announcement_attributes.max_announcement_position = position;
                }
            }
            return { queue };
        });
    }
    _getSelectedLanguage() {
        const { language, queue } = this.state;
        const selectedLanguage = (language === null || language === void 0 ? void 0 : language.toLowerCase()) || '';
        if (queue === null || queue === void 0 ? void 0 : queue.gender) {
            return `${selectedLanguage}%${queue.gender}`;
        }
        return `${selectedLanguage}%female`;
    }
    renderAnnouncementQueue() {
        var _a;
        const { flowLanguages } = this.props;
        const { queue: { announcement_attributes }, errors, } = this.state;
        const languages = flowLanguages.map(({ value, label, type }) => ({
            id: `${value}%${type}`,
            value: `${value}%${type}`,
            name: label,
        }));
        const maxAnnouncementPosition = (_a = announcement_attributes === null || announcement_attributes === void 0 ? void 0 : announcement_attributes.max_announcement_position) !== null && _a !== void 0 ? _a : '';
        const selectedLanguage = this._getSelectedLanguage();
        const languageError = errors[LANGUAGE_FIELD];
        return (_jsxs(_Fragment, { children: [_jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "Set a max on how many customers can be in line. If the limit is exceeded, an announcement will be played stating all lines are busy." })), _jsxs(FormGrid, Object.assign({ className: styles.form }, { children: [_jsx(FormField, { children: _jsx(FieldWrapper, Object.assign({ helpIcon: {
                                    title: 'Max. queue position',
                                    text: 'Select how many customers should be given a queue position. If the maximum number is reached, a message will be played stating all lines are busy.',
                                }, label: "Max. queue position" }, { children: _jsx(InputText, { id: "maxAnnoucementPosition", type: "number", min: "0", max: "3600", placeholder: "E.g. 10", onChange: this.changeMaxAnnoucementPosition, value: maxAnnouncementPosition }) })) }), _jsx(FormField, { children: _jsx(FieldSelect, { required: true, searchable: true, label: "Language for number in queue", placeholder: "No language selected", helpIcon: {
                                    title: 'Language for number in queue',
                                    text: 'Which language the "you are number # in line" message should be in.',
                                }, input: {
                                    name: 'select-language',
                                    value: selectedLanguage,
                                    onChange: this.changeLanguage,
                                }, meta: { error: languageError }, selectedItems: [selectedLanguage], items: languages }) })] }))] }));
    }
    renderTimeout() {
        const { errors, queue: { queue_timeout: { timeout_in_seconds } = {} }, } = this.state;
        const timeoutError = errors[TIMEOUT_FIELD];
        return (_jsxs(_Fragment, { children: [_jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "Select how long the customer should wait in line before a new action is triggered." })), _jsx(FormGrid, Object.assign({ className: styles.form }, { children: _jsx(FormField, { children: _jsx(Duration, { duration: timeout_in_seconds, label: "Set a timeout", meta: { error: timeoutError }, onChange: this.changeTimeoutInSec }) }) }))] }));
    }
    renderCustomWaitMusic() {
        const { queue: { wait_music_v2 }, errors, } = this.state;
        const waitMusicError = errors[WAIT_MUSIC_FIELD];
        return (_jsxs(_Fragment, { children: [_jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "Record or upload wait music that will play for your customers while they are waiting in the queue." })), _jsx(AnnouncementPicker, { className: styles.announcementPicker, adapter: AdapterTypes.WaitMusic, onSelect: this.updateAudio, selectedAudio: wait_music_v2, dropdownProps: { dropdown: null, fixed: true }, fieldProps: {
                        className: styles.fieldWrapper,
                        meta: { error: waitMusicError },
                    }, withRecord: false })] }));
    }
    getCallbackInfo() {
        const { callbackInfo } = this.state;
        const { nodes, node } = this.props;
        const callbackBefore = getRelevantAncestorWithCallback(nodes, node);
        if (callbackBefore !== null) {
            if (callbackBefore.nodeType === 'queue' &&
                callbackBefore.payload.callbackInfo) {
                return callbackBefore.payload.callbackInfo;
            }
            if (callbackBefore.nodeType === 'callback') {
                return {
                    announcement: callbackBefore.payload.announcement,
                    digit: callbackBefore.payload.digit,
                    from_number: callbackBefore.payload.from_number,
                };
            }
        }
        return callbackInfo;
    }
    renderCallback() {
        var _a, _b;
        const { errors } = this.state;
        const { nodes, node } = this.props;
        const callbackInfo = this.getCallbackInfo();
        const isDisabled = hasAncestralCallback(nodes, node);
        const announcementError = errors[ANNOUNCEMENT_FIELD];
        const callbackTimeoutError = errors[CALLBACK_TIMEOUT_FIELD];
        return (_jsxs(_Fragment, { children: [_jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "If you don't want your customers to wait in a queue for too long, you can offer them a callback. Record or upload an announcement telling your customers that they can get a callback by pressing #. You should also inform them that they keep their place in the queue." })), _jsxs(FormGrid, Object.assign({ className: styles.form }, { children: [_jsx(FormField, { children: _jsx(AnnouncementPicker, { selectedAudio: (_a = callbackInfo === null || callbackInfo === void 0 ? void 0 : callbackInfo.announcement) === null || _a === void 0 ? void 0 : _a.file, onSelect: this.handleAnnouncementSelect, adapter: AdapterTypes.Announcement, fieldProps: { meta: { error: announcementError } }, disabled: isDisabled }) }), _jsx(FormField, { children: _jsx(Duration, { className: styles.callbackTimeout, duration: callbackInfo === null || callbackInfo === void 0 ? void 0 : callbackInfo.timeout, label: "Select how many minutes the customer should wait in line before being offered a callback.", meta: { error: callbackTimeoutError }, onChange: this.handleTimeoutChange }) }), _jsx(FormField, { children: _jsx(FieldWrapper, Object.assign({ label: "Select callback outbound number" }, { children: _jsx(NumberSelect, { selectedNumber: (_b = callbackInfo === null || callbackInfo === void 0 ? void 0 : callbackInfo.from_number) !== null && _b !== void 0 ? _b : '', onSelect: this.handleOutboundNumberSelect, disabled: isDisabled }) })) })] }))] }));
    }
    render() {
        const { node, nodes, nodeLabel, triggerClose } = this.props;
        const { payload } = node;
        const { errors, queue: { queue: selectedQueue, announcement_attributes, queue_timeout }, showCallbackAnnouncement, showCustomWaitMusic: isCustomWaitMusicEnabled, } = this.state;
        const isPlayAnnouncementEnabled = !!(announcement_attributes === null || announcement_attributes === void 0 ? void 0 : announcement_attributes.play_announcement);
        const isQueueTimeoutEnabled = !!queue_timeout;
        const queueError = errors[QUEUE_FIELD];
        const hasCallbackBefore = hasAncestralCallback(nodes, node);
        const isChanged = this.initShowWaitMusic !== isCustomWaitMusicEnabled ||
            this.initShowCallbackAnnouncement !== showCallbackAnnouncement ||
            !isEqual(payload, this._getPayload());
        return (_jsxs("div", Object.assign({ className: styles.wrapper }, { children: [_jsx(ModalHead, { title: nodeLabel, className: styles.modalHead, onClose: triggerClose }), _jsxs(ModalBody, Object.assign({ className: styles.modalBody }, { children: [_jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "The queue is where you\u2019d like your incoming conversations to end up based on the queues you\u2019ve set up. Haven\u2019t made any custom queues yet? Go to Settings > Queues > Add queue" })), _jsxs(FormGrid, Object.assign({ className: styles.form }, { children: [_jsx(FormField, { children: _jsx(QueuePicker, { required: true, selectedQueue: selectedQueue, label: "Select queue", placeholder: "No queue selected", meta: { error: queueError }, input: {
                                            name: 'select-queue',
                                            onChange: this.changeQueue,
                                        } }) }), _jsx(FormField, { children: _jsx(ToggleBox, Object.assign({ isOpen: isPlayAnnouncementEnabled, headComponent: ToggleBoxHead, title: "Announce queue position", input: {
                                            id: 'queue-position',
                                            name: 'announce queue position',
                                            value: 'queue-position',
                                        }, helpIcon: {
                                            title: 'Announce queue position',
                                            text: 'Let your customers know what queue position they’re in while they’re waiting.',
                                        }, onChange: this.togglePlayAnnouncements }, { children: _jsx(ToggleBoxBody, { children: this.renderAnnouncementQueue() }) })) }), _jsx(FormField, { children: _jsx(ToggleBox, Object.assign({ isOpen: isQueueTimeoutEnabled, headComponent: ToggleBoxHead, title: "Timeout", input: {
                                            id: 'timeout',
                                            name: 'timeout',
                                            value: 'timeout',
                                        }, helpIcon: {
                                            title: 'Timeout',
                                            text: 'Select how many seconds the customer should wait in line before a new action is triggered.',
                                        }, onChange: this.toggleEnableTimeout }, { children: _jsx(ToggleBoxBody, { children: this.renderTimeout() }) })) }), _jsx(FormField, { children: _jsx(ToggleBox, Object.assign({ isOpen: isCustomWaitMusicEnabled, headComponent: ToggleBoxHead, title: "Custom wait music", input: {
                                            id: 'custom-wait-music',
                                            name: 'custom wait music',
                                            value: 'custom-wait-music',
                                        }, helpIcon: {
                                            title: 'Custom wait music',
                                            text: 'Upload an audio file that’ll play custom music while your customers wait in line.',
                                        }, onChange: this.toggleEnableCustomWaitMusic }, { children: _jsx(ToggleBoxBody, { children: this.renderCustomWaitMusic() }) })) }), _jsx(FormField, { children: _jsx(Tooltip, Object.assign({ head: "Callback best practices", content: _jsxs(_Fragment, { children: ["You've already enabled a callback option in a queue action further up, which has added a callback announcement for this entire branch.", _jsx("br", {}), _jsx("br", {}), "Go to the queue action with the callback to edit or turn it off."] }), disabled: !hasCallbackBefore, placement: "right" }, { children: _jsx(ToggleBox, Object.assign({ isOpen: showCallbackAnnouncement || hasCallbackBefore, headComponent: ToggleBoxHead, title: "Callback", input: {
                                                disabled: hasCallbackBefore,
                                                id: 'callback',
                                                name: 'callback',
                                                value: 'callback',
                                            }, helpIcon: {
                                                title: 'Callback',
                                                text: 'Offer your customers a callback if you don’t want them to wait in the queue for too long.',
                                            }, onChange: this.handleCallbackToggle }, { children: _jsx(ToggleBoxBody, { children: this.renderCallback() }) })) })) })] }))] })), _jsx(ModalFoot, { confirmOnClick: this.saveClickHandler, confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: triggerClose })] })));
    }
}
__decorate([
    boundMethod
], QueueModalImpl.prototype, "saveClickHandler", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "_getPayload", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "_prepareNode", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "_validate", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "changeQueue", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "toggleEnableTimeout", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "togglePlayAnnouncements", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "handleCallbackToggle", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "changeLanguage", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "changeTimeoutInSec", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "toggleEnableCustomWaitMusic", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "updateAudio", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "handleAnnouncementSelect", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "handleOutboundNumberSelect", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "handleTimeoutChange", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "changeMaxAnnoucementPosition", null);
__decorate([
    boundMethod
], QueueModalImpl.prototype, "_getSelectedLanguage", null);
const mapStateToProps = (state) => ({
    flowLanguages: selectFlowLanguagesSorted(state),
});
export const QueueModal = connect(mapStateToProps)(QueueModalImpl);
